/**
 * Utility function to merge Tailwind CSS classes
 * Similar to clsx but optimized for Tailwind
 */
export function cn(...inputs) {
  const classes = inputs
    .filter(Boolean)
    .map(input => {
      if (typeof input === 'string') {
        return input;
      }
      if (Array.isArray(input)) {
        return input.filter(Boolean).join(' ');
      }
      if (typeof input === 'object' && input !== null) {
        return Object.entries(input)
          .filter(([_, value]) => Boolean(value))
          .map(([key]) => key)
          .join(' ');
      }
      return '';
    })
    .join(' ')
    .split(' ')
    .filter(Boolean)
    .join(' ');

  return classes;
}
